import React from 'react'
import Image from 'next/image'
import { Box, useTheme } from '@mui/material'
import FONTS from '@/src/fonts'
import pushRoute from '@/lib/pushRoute'
import getRoutes from '@/lib/getRoutes'
import DisplayLogoBrands from '@/components/HomeNotConnected/DisplayLogoBrands'

const BlockLeader: React.FC = () => {
  const theme = useTheme()
  return (
    <>
      <div style={{ textAlign: 'center' }}>
        <Box
          sx={{
            color: theme.palette.text.primary,
            fontWeight: FONTS.WEIGHT.BOLD,
            fontSize: theme.typography.pxToRem(18),
            padding: 4,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            cursor: 'pointer',
          }}
          onClick={() => {
            pushRoute(getRoutes({ route: 'OctLeader' }))
          }}
        >
          Voir tous nos laboratoires leaders
          <Image
            src={'/images/icons/home/fleche_droite.png'}
            alt={'next'}
            width={33}
            height={23}
            style={{ marginLeft: 8 }}
          />
        </Box>
      </div>
      <div>
        <DisplayLogoBrands
          nbMarque={16}
          height={100}
          width={160}
          folder={'/images/marques-home/leader/'}
        />
      </div>
    </>
  )
}

export default BlockLeader
